<div class="main-content">
    <div class="row container-fluid">
        <div class="col-md-12">

            <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                <h1 class="h3 mb-0 text-gray-800">Results</h1>
                <div class="buttons-container">
                    <a [routerLink]="['/app','business_inteligence']" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        <i class="fas fa-long-arrow-alt-left text-white-50"> <span class="button-text">Back</span></i>
                    </a>
                    <a class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        <i class="fas fa-download text-white-50"> <span class="button-text">Download</span></i>
                    </a>
                </div>
                
            </div>

            <div class="card shadow container-fluid">
                <!--<div class="row header">
                    <div class="col-md-10">
                        <span class="subtitle">Results</span>
                    </div>
                    <div class="col-md-2 text-right">
                        <i [routerLink]="['/app','datavisualizer']" title="Back to Data Visualizer" class="material-icons">undo</i>
                        <i class="material-icons" title="Download">file_download</i>
                    </div>
                </div>-->
                <!--<hr />-->
                <div class="row">
                    <div class="col-md-1 text-right">
                        <label>Query: </label>
                    </div>
                    <div class="col-md-11">
                        <input class="input_readonly" type="text"
                               readonly
                               value="SHOW Assessment.Name, Coach.Name, Purchase.Date WHERE Purchase.Date >= 04/01/2018 ORDER BY Purchase.Date DES" />
                    </div>
                </div>
                <br />

                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th *ngFor="let title of headers">{{title}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of data">
                                        <td>{{row.assessment}}</td>
                                        <td>{{row.coach}}</td>
                                        <td>{{row.date}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
